import Medusa from '@adoratorio/medusa';
import anime from 'animejs';
import { isMobile } from '@/scripts/utils';

export default {
  id: 'showText',
  nodes: [],
  container: document.getElementById('app'),
  threshold: isMobile() ? 0.3 : Medusa.THRESHOLD.HALF,
  offsets: '0px 0px 0px 0px',
  emitGlobal: false,
  callback: (el) => {
    el.target.removeAttribute('data-showText');

    anime({
      targets: el.target.splitted.lines,
      autoplay: true,
      opacity: {
        value: 1,
        easing: 'easeInQuart',
        duration: 700,
      },
      translateY: {
        value: 0,
        easing: 'easeOutQuart',
      },
      duration: 1000,
      delay: anime.stagger(100),
    });
  },
  mode: Medusa.MODE.ONCE,
};
